import { UserReportHover as AntdUserReportHover } from "@empglabs/backoffice-ui-kit"

const UserReportHover = props => {
  return <AntdUserReportHover {...props} />
}

export default UserReportHover
